/* ============================================================
   CUSTOM FIXES — beminimum theme
   File: assets/custom-fixes.js

   Fix 1: Mobile sticky ATC always sends correct selected variant
           (not the default first variant XS-34)

   Root cause: Minimog's updateVariantInput() in variant-picker.js
   only updates forms with IDs matching:
     #product-form-{sectionId}
     #product-form-installment
   The sticky ATC form ID is "sticky-atc-form-{sectionId}" and uses
   a <select name="id"> — it is NEVER updated by the variant picker.

   Fix: Subscribe to Minimog's real pubsub event
     `${productId}__VARIANT_CHANGE`
   via window.MinimogEvents, then write the new variant.id into the
   sticky ATC select (and any hidden input fallback).
   ============================================================ */

(function () {
  'use strict';

  /* ── Wait for MinimogEvents to be available (it loads async) ── */
  function waitForMinimogEvents(callback, attempts) {
    attempts = attempts || 0;
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
      callback();
    } else if (attempts < 50) {
      setTimeout(function () {
        waitForMinimogEvents(callback, attempts + 1);
      }, 100);
    }
  }

  /* ── Sync ALL sticky-ATC variant selects/inputs to variantId ── */
  function syncStickyForms(variantId) {
    if (!variantId) return;

    /* <select name="id"> inside sticky-atc forms */
    var selects = document.querySelectorAll(
      '[id^="sticky-atc-form-"] select[name="id"],' +
      '.m-sticky-addtocart select[name="id"],' +
      '[data-view="sticky-atc"] select[name="id"]'
    );
    selects.forEach(function (sel) {
      sel.value = String(variantId);
    });

    /* hidden <input name="id"> fallback (some theme versions) */
    var inputs = document.querySelectorAll(
      '[id^="sticky-atc-form-"] input[name="id"],' +
      '.m-sticky-addtocart input[name="id"],' +
      '[data-view="sticky-atc"] input[name="id"]'
    );
    inputs.forEach(function (inp) {
      inp.value = String(variantId);
    });
  }

  /* ── Subscribe using MinimogEvents for each sticky-atc on page ─ */
  function subscribeMinimogEvents() {
    /* Find every <sticky-atc data-product-id="..."> on the page */
    var stickyAtcEls = document.querySelectorAll('sticky-atc[data-product-id]');

    if (stickyAtcEls.length === 0) {
      /* Fallback: read product ID from the main product form */
      var mainForm = document.querySelector(
        'product-form[data-product-id],' +
        '.m-product-form[data-product-id],' +
        'form[data-product-id][action*="/cart/add"]'
      );
      if (mainForm) {
        var pid = mainForm.getAttribute('data-product-id');
        if (pid) {
          window.MinimogEvents.subscribe(pid + '__VARIANT_CHANGE', function (variant) {
            if (variant && variant.id) syncStickyForms(variant.id);
          });
        }
      }
      return;
    }

    stickyAtcEls.forEach(function (el) {
      var productId = el.getAttribute('data-product-id');
      if (!productId) return;

      window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
        if (variant && variant.id) syncStickyForms(variant.id);
      });
    });
  }

  /* ── Fallback Method A: MutationObserver on main product form ─ */
  function observeMainFormInput() {
    var mainForm = document.querySelector(
      '.m-main-product product-form,' +
      '.m-main-product form[action*="/cart/add"],' +
      'product-form'
    );
    if (!mainForm) return;

    var observer = new MutationObserver(function () {
      var input = mainForm.querySelector('input[name="id"]');
      if (input && input.value) syncStickyForms(input.value);
    });

    observer.observe(mainForm, {
      attributes: true,
      attributeFilter: ['value'],
      childList: true,
      subtree: true
    });
  }

  /* ── Fallback Method B: Intercept variant option clicks ──────── */
  function interceptVariantClicks() {
    document.addEventListener('click', function (e) {
      var optionBtn = e.target.closest(
        '.m-product-option--item button,' +
        '.m-product-option--swatch,' +
        '.m-product-option--size,' +
        '[data-option-value],' +
        '.m-product-variant-picker button'
      );
      if (!optionBtn) return;

      /* Minimog updates the hidden input after the click handler,
         so read it on the next tick */
      setTimeout(function () {
        var input = document.querySelector(
          '.m-main-product product-form input[name="id"],' +
          'product-form input[name="id"]'
        );
        if (input && input.value) syncStickyForms(input.value);
      }, 50);
    });
  }

  /* ── Fallback Method C: Sync right when sticky ATC is clicked ── */
  function interceptStickyATCClick() {
    document.addEventListener('click', function (e) {
      var stickyBtn = e.target.closest(
        '.m-sticky-addtocart button[type="submit"],' +
        '.m-sticky-addtocart .m-add-to-cart,' +
        '[data-view="sticky-atc"] button[type="submit"]'
      );
      if (!stickyBtn) return;

      var input = document.querySelector(
        '.m-main-product product-form input[name="id"],' +
        'product-form input[name="id"]'
      );
      if (input && input.value) syncStickyForms(input.value);
    }, true); /* useCapture = true — runs before form submit */
  }

  /* ── Boot ─────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {

    /* Primary fix: use MinimogEvents pubsub */
    waitForMinimogEvents(subscribeMinimogEvents);

    /* Fallbacks for safety */
    observeMainFormInput();
    interceptVariantClicks();
    interceptStickyATCClick();

    /* Sync on initial load so sticky ATC starts on correct variant */
    setTimeout(function () {
      var input = document.querySelector(
        '.m-main-product product-form input[name="id"],' +
        'product-form input[name="id"]'
      );
      if (input && input.value) syncStickyForms(input.value);
    }, 800);

  });

})();